import { ArService } from './../../services/ar.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';

@Component({
  selector: 'app-add-tax-service',
  templateUrl: './add-tax-service.component.html',
  styleUrls: ['./add-tax-service.component.scss']
})
export class AddTaxServiceComponent implements OnInit {

  minDate = new Date();
  today = moment().format('MM/DD/YYYY');
  taxTypes = ['AMEX', 'Retail'];
  statusTypes = [{
    id: false,
    name: "InActive"
  },
  {
    id: true,
    name: "Active"
  }
  ]

  taxForm: FormGroup;
  isEditMode = false;
  formTitle = '';
  submitted = false
  taxData: any;
  selectedStations = [];
  allStations: any;
  selectedTaxType: any;
  taxByStationId;
  taxServicesId;
  isAmountChanged = false;
  taxId;

  public constructor(
    private notifier: NotifierService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private authService: AuthenticationService,
    private router: Router,
    private arService: ArService) {
  }

  ngOnInit() {
    this.getStations();
    if (this.route.snapshot.paramMap.get('taxId') != null) {
      this.taxId = this.route.snapshot.paramMap.get('taxId');
      this.formTitle = "Update Tax Slabs";
      this.isEditMode = true;
      this.getTaxId(this.route.snapshot.paramMap.get('taxId'));
    } else {
      this.formTitle = "Add Tax Slabs"
    }  
    this.initAddTaxForm();
  }

  getStations() {
    this.arService.getAllstationsWithCode().subscribe((stationData)=>{
      this.allStations = stationData['result']
    })
  }

  getTaxId(taxId) {
    this.selectedStations = [];
    this.spinner.show();
    this.arService.getTaxDataById(taxId).subscribe(tData => {
      this.taxData = tData['result']
      this.selectedStations.push(this.taxData[0].STATION);
      this.spinner.hide();
      this.initUpdateTaxForm();
    });
  }

  onAddTax(values) {
    this.submitted = true;
    this.validateTax();
    this.taxForm.markAllAsTouched();
    if (this.taxForm.invalid) {
      return;
    }
    
    var data = {
      STATION: values.station,
      TAX_SLAB: values.tax_Slab,
      TAX_LABEL: values.tax_Label,
      TAX_LABEL_DESCRIPTION: values.tax_Label_Description,
      LCB_ID: this.authService.getCurrentUserId(),
      ACTIVE: true
    }

    this.spinner.show()
    this.arService.addTaxRatesData(data).subscribe(res => {
      if (res['status']) {
        this.spinner.hide()
        this.submitted = false
        this.notifier.notify('success', res['message']);
        this.initAddTaxForm();
      } else {
        this.submitted = false
        this.spinner.hide()
        this.notifier.notify('danger', `Already available for this station, soo ${res['message']} `)
      }
    }, err => {
      this.notifier.notify('danger', err.message)
       console.log(err);
    })
    this.router.navigateByUrl("home/tax");
  }


  initAddTaxForm() {
    this.taxForm = new FormGroup({
      station: new FormControl('', Validators.compose([Validators.required])),      
      tax_Slab: new FormControl('', Validators.compose([Validators.required])),
      tax_Label: new FormControl('', Validators.compose([Validators.required])),
      tax_Label_Description: new FormControl('', Validators.compose([Validators.required]))
    });
  }

  initUpdateTaxForm() {
    this.taxForm = this.formBuilder.group({
      station: new FormControl(this.taxData[0].STATION, Validators.compose([Validators.required])),
      tax_Slab: new FormControl(this.taxData[0].TAX_SLAB, Validators.compose([Validators.required])),
      tax_Label: new FormControl(this.taxData[0].TAX_LABEL, Validators.compose([Validators.required])),
      tax_Label_Description: new FormControl(this.taxData[0].TAX_LABEL_DESCRIPTION, Validators.compose([Validators.required]))
    });
  }

  get taxFormcontrols() { return this.taxForm.controls; }

  onUpdateTax(values) {
    this.submitted = true
    this.validateTax();
    this.taxForm.markAllAsTouched();
    if (this.taxForm.invalid) {
      return;
    }

    var data = {
      STATION: values.station,
      TAX_SLAB: values.tax_Slab,
      TAX_LABEL: values.tax_Label,
      TAX_LABEL_DESCRIPTION: values.tax_Label_Description,
      TAX_ID: parseInt(this.taxId),
      LCB_ID: this.authService.getCurrentUserId(),
      ACTIVE: true
    }

    this.spinner.show();
    this.arService.updateTaxData(data).subscribe(res => {
      this.spinner.hide();
      if (res['status']) {
        this.notifier.notify('success', res['message']);
        setTimeout(() => {
          this.ngOnInit();
        }, 1000);
      } else {
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
      console.log(err);
    })
    this.router.navigateByUrl("home/tax");
  }

  onStationChange(event) {
    this.selectedStations = (event)
  }

  validation_messages = {
    'station': [
      { type: 'required', message: 'Station is required.' }
    ],
    'tax_Slab': [
      { type: 'required', message: 'Tax Slab is required.' }
    ],
    'tax_Label': [
      { type: 'required', message: 'Tax Label is required.' }
    ],
    'tax_Label_Description': [
      { type: 'required', message: 'Tax Label Description is required.' }
    ],    
  }

  get f(): any {
    return this.taxForm.controls;
  }

  onBack() {
    this.router.navigateByUrl("home/tax");
  }

  validateTax() {
    if (this.taxFormcontrols.station.errors) {
      this.notifier.notify('warning', 'Please select Station ');
      return false;
    }
    if (this.taxFormcontrols.tax_Slab.errors) {
      this.notifier.notify('warning', 'Please enter Tax Slab');
      return false;
    }
    if (this.taxFormcontrols.tax_Label.errors) {
      this.notifier.notify('warning', 'Please enter Tax Label');
      return false;
    }
    if (this.taxFormcontrols.tax_Label_Description.errors) {
      this.notifier.notify('warning', 'Please enter Tax Label Description');
      return false;
    }
  }

}
